import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock, Phone, Mail } from 'lucide-react';
export function HoursLocation() {
  return <section id="location" className="py-24 bg-white" data-id="element-173">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-174">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-175">
          {/* Info Side */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-176">
            <h2 className="font-serif text-4xl text-charcoal mb-10" data-id="element-177">
              Visit Us
            </h2>

            <div className="space-y-8" data-id="element-178">
              <div className="flex items-start" data-id="element-179">
                <MapPin className="text-warm-brown mt-1 mr-4 flex-shrink-0" size={24} data-id="element-180" />
                <div data-id="element-181">
                  <h4 className="font-bold text-charcoal uppercase tracking-wider text-sm mb-2" data-id="element-182">
                    Location
                  </h4>
                  <p className="text-gray-600 text-lg" data-id="element-183">
                    207 Broadway St.
                    <br data-id="element-184" />
                    Paducah, KY 42001
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-185">
                <Clock className="text-warm-brown mt-1 mr-4 flex-shrink-0" size={24} data-id="element-186" />
                <div data-id="element-187">
                  <h4 className="font-bold text-charcoal uppercase tracking-wider text-sm mb-2" data-id="element-188">
                    Hours
                  </h4>
                  <ul className="text-gray-600 text-lg space-y-1" data-id="element-189">
                    <li className="flex justify-between w-56" data-id="element-190">
                      <span data-id="element-191">Mon - Thu:</span> <span data-id="element-192">4pm - 9pm</span>
                    </li>
                    <li className="flex justify-between w-56" data-id="element-193">
                      <span data-id="element-194">Fri - Sat:</span> <span data-id="element-195">4pm - 10pm</span>
                    </li>
                    <li className="flex justify-between w-56 text-warm-brown font-medium" data-id="element-196">
                      <span data-id="element-197">Sunday:</span> <span data-id="element-198">Closed</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="flex items-start" data-id="element-199">
                <Phone className="text-warm-brown mt-1 mr-4 flex-shrink-0" size={24} data-id="element-200" />
                <div data-id="element-201">
                  <h4 className="font-bold text-charcoal uppercase tracking-wider text-sm mb-2" data-id="element-202">
                    Contact
                  </h4>
                  <p className="text-gray-600 text-lg" data-id="element-203">(270) 933-1707</p>
                  <p className="text-gray-600 text-lg mt-1" data-id="element-204">
                    CheahFamilyFoods@gmail.com
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Map Placeholder */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="h-full min-h-[400px] bg-warm-gray relative rounded-sm overflow-hidden shadow-inner flex items-center justify-center border border-gray-200" data-id="element-205">
            <div className="text-center p-6" data-id="element-206">
              <MapPin size={48} className="text-warm-brown/40 mx-auto mb-4" data-id="element-207" />
              <h3 className="font-serif text-xl text-charcoal mb-2" data-id="element-208">
                Map Placeholder
              </h3>
              <p className="text-sm text-gray-500 max-w-xs mx-auto" data-id="element-209">
                An interactive Google Map or stylized map image of downtown
                Paducah will be placed here.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}